import { render, staticRenderFns } from "./TopBtns.vue?vue&type=template&id=7ca6c903&scoped=true&"
import script from "./TopBtns.vue?vue&type=script&lang=js&"
export * from "./TopBtns.vue?vue&type=script&lang=js&"
import style0 from "./TopBtns.vue?vue&type=style&index=0&id=7ca6c903&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca6c903",
  null
  
)

export default component.exports